import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';

import { Subscription } from 'rxjs';
import { ExportChannel } from '../../../interfaces/exportchannel';
import { Mediaclip } from '../../../interfaces/mediaclip';
import { BbTableService, BbTableSelectOption, TableRow } from '../../../services/bb-table.service';

@Component({
	selector: 'social-facebook-synced',
	templateUrl: './social-facebook-synced.component.html',
	styleUrls: ['./social-facebook-synced.component.scss'],
	providers: [BbTableService]
})

export class SocialFacebookSyncedComponent implements OnInit, OnChanges, OnDestroy {

	@Input() channel: ExportChannel;

	rows: TableRow[] = null;
	getRowsSubscription: Subscription;
	filter = 'all';

	constructor(private bbTableService: BbTableService, protected router: Router) { }

	ngOnInit() {
		this.bbTableService
			.setIdentifier('social-facebook-synced')
			.setSelect(BbTableSelectOption.none)
			.setLimit(15)
			.setConfigurable(false)
			.sort('id', 'desc')
			.setEntity('mediaclip');

		this.getRowsSubscription = this.bbTableService.rowsRetrievedObservable.subscribe((rows: TableRow[]) => {
			this.rows = rows;
		});
	}

	filterChanged() {
		if (this.channel && this.channel.id) {
			this.updateData();
		}
	}

	ngOnChanges(changes: SimpleChanges) {
		if (typeof changes.channel !== 'undefined') {
			if (this.channel && this.channel.id) {
				this.updateData();
			}
		}
	}

	redirectToMediaclip(clip: Mediaclip) {
		this.router.navigate(['library/mediaclip', clip.id, 'metadata']);
	}

	updateData() {
		const queries: string[] = [];
		const channelPrefix = this.channel.exportsystemname;

		switch (this.filter) {
			case 'new':
				queries.push(channelPrefix + '_status:[* TO *])');
				break;
			case 'queued':
				queries.push(channelPrefix + '_status:"new"');
				break;
			case 'failed':
				queries.push(channelPrefix + '_status:"error"');
				break;
			case 'exported':
				queries.push(channelPrefix + '_status:"exported"');
				break;
		}
		queries.push('exportchannelid:' + this.channel.id);

		this.bbTableService
			.setFilterQuery(queries)
			.getRows(true);
	}

	ngOnDestroy() {
		this.getRowsSubscription.unsubscribe();
	}
}
